// Phase B: 자동차관리법 제57조의2 제3항 대응 — 프론트엔드 feature flag 헬퍼
// 시행일: 2026-06-03 (법률 제21182호)
//
// ⚠️ 동기화 필요: autodoc/utils/lawEnforcement.js (백엔드)
// LAW_ENFORCEMENT_DATE 변경 시 양쪽 모두 수정
//
// Wave 2.3: CarRegister / CarRegisterForm / CarRegisterBulk 에서 UI 분기용
// 백엔드는 매 요청 시 process.env.LAW_ENFORCEMENT_DATE 로 재판정하므로
// 프론트가 틀려도 최종 가드는 백엔드에서 작동 (defence in depth).

export var LAW_ENFORCEMENT_DATE = '2026-06-03';

export function isLawEnforced() {
  var today = new Date().toISOString().slice(0, 10);
  return today >= LAW_ENFORCEMENT_DATE;
}
